const hasSlideShow = () => document.querySelector('.slideshow-hero.home-hero-only');

document.addEventListener('DOMContentLoaded', () => {
  if (!hasSlideShow()) return;
  const mainEl = document.querySelector('.template-index main');
  mainEl.style.paddingBottom = '0';
});
